import { useMemo } from 'react'
import { Meter } from 'portal/components/Utilities/Meters/Interface'
import { Select } from 'antd'
import styled from 'styled-components'

type SelectMeterProps = {
  selectedMeterId: string
  setSelectedMeterId: (meter: string) => void
  meters: Meter[]
  showLabel?: boolean
}

type SelectOption = {
  label: string
  value: string
  ref: string
}

export function SelectMeter({
  selectedMeterId,
  setSelectedMeterId,
  meters,
  showLabel = false
}: SelectMeterProps) {
  const selectableMeters: SelectOption[] = useMemo(
    () =>
      meters.map(meter => ({
        label: meter.meterName,
        value: meter.meterId ? meter.meterId : '',
        ref: meter.meterReference ? meter.meterReference : ''
      })),
    [meters]
  )

  const handleOnChange = (value: any) => {
    setSelectedMeterId(value)
  }

  return (
    <>
      {showLabel && (
        <StyledLabel htmlFor="labelledMeterSelector">Meter</StyledLabel>
      )}
      <StyledSelect
        id={showLabel ? 'labelledMeterSelector' : 'meterSelect'}
        value={selectedMeterId ? selectedMeterId : undefined}
        allowClear
        showSearch
        placeholder="Select meter"
        options={selectableMeters}
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) ||
          (option?.ref ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={handleOnChange}
      />
    </>
  )
}

const StyledLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
`
const StyledSelect = styled(Select)`
  width: 16.5rem;
`
